<template>
    <div v-if="data &&  data.bids" >
        <v-menu
            v-model="menu"
            offset-y
            nudge-top="-5"
            max-width="675"
            :close-on-content-click="false"
            content-class="dialog-border"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    :color="color"
                    v-bind="attrs"
                    v-on="on"
                    rounded
                    small
                    class="bid-menu-button"
                >
                    <span>Angebote</span><i class="fa fa-caret-down ml-1"></i>
                </v-btn>
            </template>

            <div>
                <v-container class="white bid-scroll-panel">
                    <p-inc-bid-summary
                        v-for="(bid,index) in bids"
                        :key = "index"
                        :bid = bid
                    />
                </v-container>
            </div>
        </v-menu>
    </div>
</template>

<script>

import PIncBidSummary from "@/modules/inc/steps/components/repair/private/PIncBidSummary.vue";

export default {
    name: "IncBidOverview",
    components: {
        PIncBidSummary
    },

    props: {
        data: {
            required: true,
            type    : Object,
            default: function () {
                return {
                    bids: [],
                }
            }
        },
        color: {

        }
    },

    data: () => ({
        menu: false
    }),

    computed: {
        bids () {
            return this.data.bids.filter(bid => bid.active);
        },
    }
}
</script>

<style scoped>

.bid-menu-button {
    text-transform: none;
    letter-spacing: unset;
    text-indent: unset;
    font-size: 10pt;
    color: white;
}

.bid-scroll-panel {
    overflow-y: scroll;
    overflow-x: hidden;
    max-height: 700px;
    padding: 16px 4px 8px 8px;
}

</style>